module.exports = __webpack_public_path__ + "img/battery-three-quarters.295673b9.svg";